import { IconProps } from "../../utils/global-types/global-types";

const EmptyCircleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default EmptyCircleIcon;
